export const mockUsers = [
  {
    id: 1,
    username: "admin",
    password: "admin123",
    name: "Rajesh Kumar",
    role: "Super Admin",
    email: "admin@surveyproerp.com",
    avatar: "RK",
    permissions: ["all"],
  },
  {
    id: 2,
    username: "manager",
    password: "manager123",
    name: "Priya Sharma",
    role: "Survey Manager",
    email: "priya@surveyproerp.com",
    avatar: "PS",
    permissions: ["jobs", "clients", "reports", "billing"],
  },
  {
    id: 3,
    username: "staff",
    password: "staff123",
    name: "Amit Patel",
    role: "Office Staff",
    email: "amit@surveyproerp.com",
    avatar: "AP",
    permissions: ["jobs", "clients"],
  },
  {
    id: 4,
    username: "client",
    password: "client123",
    name: "Sunita Reddy",
    role: "Client Portal User",
    email: "sunita@client.com",
    avatar: "SR",
    permissions: ["portal"],
  },
];

export const mockCompanySettings = {
  name: "CADSoft Survey Solutions Pvt. Ltd.",
  logo: "https://storage.readdy-site.link/project_files/5879db97-9e94-48bf-be04-c174ef541633/497af63a-0e64-4809-85b5-1474aa7321a9_icon-cadsoft-logo.svg?v=8bf3bb090434ec9bacdcf0e4de437e93",
  address: "Plot No. 45, Survey Colony, Hyderabad, Telangana - 500032",
  email: "info@cadsoft.in",
  phone: "+91 40 2345 6789",
  gstin: "36AABCG1234F1Z5",
  currency: "INR",
  country: "India",
  state: "Telangana",
  timezone: "Asia/Kolkata",
  invoicePrefix: "INV",
  jobCardPrefix: "SURV",
  branchPrefix: "HYD",
  website: "www.cadsoft.in",
};
